import { renderHTMLString } from '../../../../../../../../helpers';
import { StyledWrapper } from './styles';
import { useRootSelector } from '../../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../../store/features/pageConfig';

export interface ProductDescriptionProps {
  description: string;
}

export default function ProductDescription(props: ProductDescriptionProps) {
  const { description } = props;

  const { location } = useRootSelector(selectPageConfig);

  return (
    <StyledWrapper>
      {renderHTMLString(description, location, false)}
    </StyledWrapper>
  );
}
